import { render, staticRenderFns } from "./CertificateUpdate.vue?vue&type=template&id=447ad7c0&"
import script from "./CertificateUpdate.vue?vue&type=script&lang=js&"
export * from "./CertificateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports